import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import { useInboxesStore } from './stores/inboxes'
import { useKanbanConfigStore } from './stores/kanban-config'
import './style.css'

async function bootstrap() {
  const app = createApp(App)
  app.use(createPinia())

  // Hidrata stores ANTES do router (guards enxergam sessão persistida).
  const auth = useAuthStore()
  auth.hydrate()
  useInboxesStore().hydrate()

  // Logout automático em 401 (token expirado/revogado). Disparado pelos
  // interceptors em api/chatwoot.ts (chatwoot e kanbanApi).
  window.addEventListener('chatwoot:unauthorized', () => {
    auth.logout()
    if (router.currentRoute.value.name !== 'login') {
      router.push({
        name: 'login',
        query: { redirect: router.currentRoute.value.fullPath },
      })
    }
  })

  // SSO via cookie cross-subdomain emitido pelo chatwoot-injector.
  if (!auth.isAuthenticated) {
    await auth.trySSO()
  }

  // Carrega config dinâmica do kanban_api. Só faz sentido se o user está
  // autenticado — endpoint exige token. Em falha (backend offline), o store
  // mantém DEFAULT_STAGES como fallback e a UI continua funcional.
  if (auth.isAuthenticated) {
    await useKanbanConfigStore().load()
  }

  app.use(router)
  app.mount('#app')
}

void bootstrap()
